<template>
  <div class="card h-100">
    <div class="card-body pb-1">
      <p class="m-0">
        <small class="font-weight-bold">Department</small>
      </p>
      <highcharts :options="chartOptions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    chartOptions: {
      title: false,
      credits: false,
      chart: {
        type: 'variablepie',
        height: 320,
        margin: [0, 0, 60, 0]
      },
      tooltip: {
        headerFormat: '',
        pointFormat:
          '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>' +
          'Total: <b>{point.y}</b><br/>'
      },
      plotOptions: {
        variablepie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          center: ['70%', '55%'],
          showInLegend: true
        }
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'middle',
        itemMarginTop: 10
      },
      series: [{
        innerSize: '30%',
        dataLabels: {
          enabled: true,
          format: '<b>{point.y}</b>',
          useHtml: false,
          color: '#3f377f',
          distance: 30
        },
        data: []
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
              itemMarginTop: 100
            },
            plotOptions: {
              variablepie: {
                center: ['50%', '50%']
              }
            }
          }
        }]
      }
    }
  }),

  watch: {
    items: {
      deep: true,
      immediate: true,
      handler (val) {
        this.chartOptions.series[0].data = val.map(item => ({
          name: item.name,
          y: item.y,
          color: item.color
        }))
      }
    }
  }
}
</script>
